module.exports = __webpack_public_path__ + "cc94904702f89c10ac815463d9a3f3ac.svg";